import { DEFAULT_FLOWCODE_OPTIONS } from '@app/code/src/components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator.constants'
import { FcGeneratorOptions, FcText } from '@dtx-company/flowcode-generator-types/src'

export const doNotUseWhiteColor = (color: string | undefined, defaultColor: string): string => {
  return !color || ['#fff', '#FFF', '#ffffff', '#FFFFFF'].includes(color) ? defaultColor : color
}
export const getFlowcodeAutogeneratedOptionsWithRimText = (
  configuration: string,
  topRimText: string | undefined,
  bottomRimText: string | undefined
): FcGeneratorOptions => {
  const initialConfig = JSON.parse(configuration) as FcGeneratorOptions
  if (bottomRimText || topRimText) {
    const borderColor = doNotUseWhiteColor(
      initialConfig.containerBorderColor,
      initialConfig.gridModuleColor?.split(',')[0] || '#000000'
    )
    const containerRimText: FcText[] = []
    const fontProps = {
      font: 'centra_light',
      fontSize: 22,
      fontColor: initialConfig.gridModuleColor?.split(',')[0] || '#000000'
    }

    if (topRimText) {
      containerRimText.push({
        ...fontProps,
        text: topRimText,
        position: { property: 6, offsetPercentage: 0 }
      })
    }

    if (bottomRimText) {
      containerRimText.push({
        ...fontProps,
        text: bottomRimText,
        position: { property: 7, offsetPercentage: 0 }
      })
    }

    return {
      ...initialConfig,
      data: DEFAULT_FLOWCODE_OPTIONS.data,
      containerRimWidth: 17,
      containerBorderOutlineColor: borderColor,
      containerBorderOutlineSize: initialConfig.containerBorderOutlineSize || 2,
      containerRimBorderColor: doNotUseWhiteColor(
        initialConfig.containerRimBorderColor,
        borderColor
      ),
      containerRimBorderSize: initialConfig.containerRimBorderSize || 2,
      containerRimBackgroundColor:
        initialConfig.containerRimBackgroundColor || initialConfig.gridBackgroundColor || '#FFFFFF',
      dataGridPercentageSize: 70,
      containerRimText,
      logoModulePadding: undefined, // pattern shouldn't cover logo
      qrrotate: false // sometimes this value returned as true (espn.com example) and the code is 90 degree rotated,
    }
  } else
    return {
      ...initialConfig,
      data: DEFAULT_FLOWCODE_OPTIONS.data,
      qrrotate: false,
      logoModulePadding: undefined
    }
}
